module.exports = __webpack_public_path__ + "static/media/10_WAX.febc0169.webp";